import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=4d7ff8e5&scoped=true"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"
import style0 from "./Percentage.vue?vue&type=style&index=0&id=4d7ff8e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ff8e5",
  null
  
)

export default component.exports